import { getBeginningOfDayISOString } from "./dateHelpers";

const handleAltEnter = (event, disabled, callback, callbackArg) => {
  if (event.altKey && event.key === "Enter" && !disabled) {
    event.preventDefault();
    callback(callbackArg);
  }
};

const handleDatePickerShortcuts = (event, pressedKeys, setPressedKeys, value, callback) => {
  const keys = pressedKeys;

  keys[event.key] = true;
  setPressedKeys(keys);

  if (event.key === "n" || event.key === "N") {
    event.preventDefault();
    callback(new Date());
  } else if (event.key === "t" || event.key === "T") {
    event.preventDefault();
    let today = new Date();
    today = getBeginningOfDayISOString(today);
    callback(new Date(today));
  } else if (pressedKeys["t"] && pressedKeys["-"] && parseInt(event.key)) {
    let date = new Date();
    if (value) {
      date = value;
    }

    setTimeout(() => {
      callback(new Date(date.setDate(date.getDate() - parseInt(event.key))));
    }, 0);
  } else if (pressedKeys["t"] && parseInt(event.key)) {
    let date = new Date();
    if (value) {
      date = value;
    }

    setTimeout(() => {
      callback(new Date(date.setDate(date.getDate() + parseInt(event.key))));
    }, 0);
  }
};

export {
  handleAltEnter,
  handleDatePickerShortcuts
};